<template>

<q-item v-if="appversion && (app_state().MaintenanceON || isMaster)" dense clickable class="shadow-3 q-mt-lg"
        id="guidedtour_drawerleft_versioning">

    <q-item-section avatar><q-icon name="tag" color="light-blue-4" /></q-item-section>
    <q-item-section>
        <q-item-label>Application v{{ version_str }}</q-item-label>
                                 <!-- animated pulse infinite slower  -->
        <q-item-label v-if="isBadVersion()" caption class="text-red text-bold q-pl-md"><!--  @click.stop="showModalBadVersion = true" -->
            <q-icon name="notifications_active" color="orange" class="animated infinite tada slower q-mr-md" />
            <!-- Votre version : {{ app_state().appversion }} -->
            Votre version : {{ user?.app_version }}
        </q-item-label>
    </q-item-section>


    <q-popup-proxy v-if="user" :persistent="isMaster">
        <q-banner class="q-pa-sm">

            <p class="q-mb-xs" v-if="appversion.date">Mise à jour du {{ formatDate({datetime: appversion.date, full: true,format:'ddd, DD MMM YYYY'}) }}</p>
            <p class="q-mb-xs">v{{ version_str }}</p>
            <p class="q-mb-xs text-caption" v-if="appversion.git_branch">hash GIT: {{ appversion.git_branch }}</p>
            <p v-if="appversion.info" class="q-pl-sm q-pt-none">
                <span v-dompurify-html="nl2br(appversion.info)"></span>
            </p>
            <p>
                <q-btn v-if="appversion.old_version.length" @click="openModalOldVersions = true" icon="history" dense no-caps
                        :label="appversion.old_version.length +' Versions Précédentes'"></q-btn>
                        <!-- :label="pluralize(appversion.old_version.length, 'Ancienne Version') + (appversion.old_version.length >= maxOldVersions ? ' (max. affiché)' : '')"></q-btn> -->
            </p>

            <q-card v-if="allRight()" class="q-mt-sm q-pa-sm">
                <q-card-section class="q-my-none">
                    <div class="text-h6">Espace réservé au Webmaster</div>
                </q-card-section>
                <q-card-section>
                    <q-input class="q-mb-md" hint="En enregistrant par le bouton de ce champ, cela change juste les informations de la version actuelle, sans modifier la version..."
                            label="Infos de la nouvelle version" type="textarea" rows="7" autogrow
                                    v-model="appversion.info">
                        <template v-slot:after>
                            <q-btn @click="writeInJson('info')" icon="save" flat></q-btn>
                        </template>
                    </q-input>


                    <q-field class="q-my-md">
                        <q-checkbox v-if="!openCustomDate"
                                    v-model="saveDateToday" label="Enregistrer la date d'aujourd'hui"></q-checkbox>

                        <!-- <q-datetime v-else v-model="customDate" format="YYYY-MM-DD HH:mm"
                                    clearable type="datetime"
                                    label="Choisir une date précise"
                                    :after="[{icon:'save', content: true, handler(){ writeInJson() }}]"></q-datetime> -->

                        <!-- <p v-else>{{ formatDate(customDate) }}</p> -->

                        <q-input v-else filled v-model="customDate" mask="####-##-## ##:##">
                            <template v-slot:prepend>
                                <q-icon name="event" class="cursor-pointer">
                                <q-popup-proxy transition-show="scale" transition-hide="scale">
                                    <q-date v-model="customDate" mask="YYYY-MM-DD HH:mm">
                                        <div class="row q-gutter-sm justify-end">
                                            <q-btn v-close-popup label="Fermer" color="primary" flat />
                                        </div>
                                    </q-date>
                                </q-popup-proxy>
                                </q-icon>
                            </template>

                            <!-- <template v-slot:append>
                                <q-icon name="access_time" class="cursor-pointer">
                                <q-popup-proxy transition-show="scale" transition-hide="scale">
                                    Q-Time...
                                    <q-time v-model="customDate" mask="YYYY-MM-DD HH:mm" format24h>
                                        <div class="row q-gutter-sm justify-end">
                                            <q-btn v-close-popup label="Fermer" color="primary" flat />
                                        </div>
                                    </q-time>
                                </q-popup-proxy>
                                </q-icon>
                            </template> -->
                        </q-input>

                        <template v-slot:before>
                            <q-btn :label="!openCustomDate ? 'Choisir une date' : 'Annuler'" no-caps dense icon="event" class="q-mt-md" color="grey" outline
                                    @click="!openCustomDate
                                            ? (saveDateToday = false, openCustomDate = true)
                                            : (saveDateToday = true, customDate = '', openCustomDate = false)"></q-btn>
                        </template>
                    </q-field>

                    <div class="row justify-around q-gutter-sm">
                        <div class="col-auto">
                            <q-btn-dropdown :label="'Majeure ('+version.major+')'" dense no-caps color="red" class="block q-mb-md">
                                <q-btn-group>
                                    <q-btn @click="decrementVersion('major')" icon="remove" no-caps></q-btn>
                                    <q-btn @click="incrementVersion('major')" icon="add" no-caps></q-btn>
                                </q-btn-group>
                            </q-btn-dropdown>
                            <q-btn-dropdown :label="'Mineure ('+version.minor+')'" dense no-caps color="orange" class="block q-mb-md">
                                <q-btn-group>
                                    <q-btn @click="decrementVersion('minor')" icon="remove" no-caps></q-btn>
                                    <q-btn @click="incrementVersion('minor')" icon="add" no-caps></q-btn>
                                </q-btn-group>
                            </q-btn-dropdown>
                            <q-btn-dropdown :label="'Correctif ('+version.patch+')'" dense no-caps color="green" class="block q-mb-md">
                                <q-btn-group>
                                    <q-btn @click="decrementVersion('patch')" icon="remove" no-caps></q-btn>
                                    <q-btn @click="incrementVersion('patch')" icon="add" no-caps></q-btn>
                                </q-btn-group>
                            </q-btn-dropdown>
                        </div>

                        <q-input class="col-auto q-mb-md" label="Modifier manuellement"
                                v-model="version_str"
                                :readonly="!updateManually">
<!--									:after="[  {icon: !updateManually ? 'touch_app' : 'cancel_presentation', content: true, handler(){ updateManually = !updateManually }},
                                                {icon: updateManually ? 'save' : '', content: true, handler(){ updateManuallyBeforeWriteInJson() }}]">-->

                            <template v-slot:prepend>
                                <q-btn @click="updateManually = !updateManually" :icon="!updateManually ? 'touch_app' : 'cancel_presentation'" dense flat></q-btn>
                            </template>
                            <template v-slot:append v-if="version_str.length">
                                <q-btn v-if="updateManually" @click="updateManuallyBeforeWriteInJson()" icon="save" dense flat></q-btn>
                            </template>
                        </q-input>

                    </div>

                    <div class="row q-mt-md">
                        <q-input v-model="appversion.git_branch"
                                label="GIT Branch" class="col-12"
                                hint="Enregistrer (séparément ou non) la version git">
                                <!-- :hide-hint="Boolean(appversion.git_branch)"
                                :readonly="Boolean(appversion.git_branch)">
                            <template #append v-if=" ! appversion.git_branch"> -->
                            <template #append>
                                <q-btn @click="writeInJson(true)" icon="save" flat />
                            </template>
                        </q-input>
                    </div>
                </q-card-section>
            </q-card>
        </q-banner>
    </q-popup-proxy>
        
	<MyDialog v-if="openModalOldVersions" v-model="openModalOldVersions" title="Anciennes Versions"
			   @update:modelValue="v => openModalOldVersions = v">

		<q-card v-for="(old, key) in appversion.old_version" :key="key" class="text-grey-8 q-mb-sm full-width">
			<q-card-section>
				<div class="text-h6 q-mt-sm q-mb-xs">v{{ old.version }}</div>
				<p class="q-mt-sm q-mb-xs">git {{ old.git_branch }}</p>
				<div class="text-overline">{{ formatDate({datetime: old.date, full: true}) }}</div>
				<!--<br/>-->
				<div class="text-caption" v-if="old.info" v-dompurify-html="nl2br(old.info)"></div>
				<!--<q-btn v-if="allRight() && old.info" @click="appversion.info = old.info" icon="content_copy" dense flat class="block"></q-btn>-->
			</q-card-section>
		</q-card>
	<!--</q-dialog>-->
	</MyDialog>


	<!-- <MyDialog v-if="showModalBadVersion" v-model="showModalBadVersion" bgcolor="red-8" persistent
			   @update:modelValue="v => { showModalBadVersion = v; stopTimerAutoRefresh() }"
               title="Mauvaise version utilisée !">

        <q-card-section class="q-my-none"><b>Attention, Vous utilisez une ancienne version de l'application !</b></q-card-section>
        <q-card-section>
            Vous pourriez éventuellement rencontrer des problèmes lors de son utilisation...
            <br/>Versions : <b>{{ app_state().appversion }}</b> => <b>{{ version_str }}</b>
        </q-card-section>
        <q-card-section class="q-my-sm">
            <q-btn-group>
                <q-btn label="Réactualiser la page" no-caps color="green" @click="refresh()" icon="refresh" :size="!$_hasTouch ? 'lg' : 'md'" />

                <q-knob v-if="timerAutoRefresh" show-value :max="20"
                        v-model="countdownAutoRefresh"
                        font-size="12px" class="text-red q-ma-xs cursor-pointer"
                        :thickness="0.05" color="red-8" readonly track-color="grey-3" size="40px"
                        @click="stopTimerAutoRefresh()">
                    <q-icon name="pause" color="grey-7" size="xs" />
                    {{ countdownAutoRefresh }}s.
                </q-knob>
            </q-btn-group>
        </q-card-section>
        <q-card-section class="full-width">

            <q-list bordered class="full-width q-pa-none">
                <MyExpansion class="full-width" dense>
                    <template #label>
                        Plus de solutions...
                    </template>

                    <q-card-section>
                        Essayer de recharger la page en ayant pris soin de correctement vider le cache de votre navigateur avant.
                        <br/>
                        <q-btn :label="'Comment vider le cache de mon navigateur '+$_.capitalize($q.platform.is.name)"
                                icon-right="open_in_new" no-caps class="q-mt-sm" color="info" :size="!$_hasTouch ? 'md' : 'sm'" dense outline
                                @click="open('https://www.google.fr/search?q=vider%20le%20cache%20navigateur%20'+$q.platform.is.name)" />
                    </q-card-section>

                    <q-card-section v-if="! $_hasTouch">
                        Plus simplement, depuis votre clavier, essayez de recharger la page par un CTRL+F5.
                    </q-card-section>
                    <q-card-section>
                        Ou vous avez également la possibilité de faire un CTRL+MAJ+Suppr
                        <br/>&nbsp;qui vous donnera accès à ce que vous voulez purger (prenez alors soin de cocher la case "Cache").
                    </q-card-section>
                    <q-card-section>
                        <small class="text-grey-7">
                            L'application est conçue pour que vous chargiez automatiquement le dernier code source lors du rechargement de la page.
                            <br/>Cependant, dans certains cas, cela ne fonctionne pas. Certains navigateurs font du zèle.
                        </small>
                    </q-card-section>

                </MyExpansion>
            </q-list>
        </q-card-section>
	</MyDialog> -->

</q-item>


<q-item v-if=" ! app_state().MaintenanceON && (isAdmin || isCarrier)">
        <q-tooltip>--- Versionning Disabled ---</q-tooltip>
    <q-item-section avatar>
        <q-icon name="tagwarning" color="warning" class="animated infinite high-slower-2 tada" />
    </q-item-section>
    <q-item-section>
        <q-item-label>Maintenance à&nbsp;Convenir...</q-item-label>
        <q-item-label caption><small>(infos invisibles par les clients)</small></q-item-label>
    </q-item-section>
    <q-item-section side>
        <Popup size="md" styles="width: 320px!important" btnClass="animated infinite slower pulse">
            <p>Dans l'éventualité qu'une maintenance mensuelle soit convenue, toutes les informations de versions de l'application seraient affichées ici.</p>
            <p>Contenant également des informations des différentes fonctionnalités mises en place au fur et à mesure, pour faciliter la navigation des utilisateurs.</p>
            <p><b>Sans parler de l'évidence qu'aura cette maintenance sur la pérennité du fonctionnement de l'application !</b>
                <!-- <br><small>Une application non mise à jour sera plus compliquée a maintenir et à faire évoluer... en résultera inéxorablement des frais non négligeables.</small> -->
            </p>
            <p>
                <q-btn label="Demander un devis pour un contrat de maintenance" icon-right="mail" square outline size="md" no-caps
                    @click.stop="link(`mailto:stephane@naxios.fr?subject=[${utils.infos?.societe}] - Demande de devis pour un contrat de maintenance`)" />
                    <!-- @click.stop="link(`mailto:${utils.infos?.webmaster_email}?subject=Demande de devis pour un contrat de maintenance`)" /> -->
            </p>
            <p><small>À défaut de contrat, des mises à jour ponctuelles seront tout de même nécessaires pour le bon fonctionnement de l'application et la stabilité du code source.</small></p>
        </Popup>
    </q-item-section>
</q-item>

</template>

<script>
import { pp, app_state, link, open, refresh, notify, e, formatDate, nl2br } from '@helpers'
import { computed, onBeforeUnmount, ref, watch } from '@vue/runtime-core'


export default {
	name: 'Versionning',
    setup(/* props, {attrs} */){

    let old_version = null // no reactive variable


        let file        = 'appversion.json'

        let appversion  = ref(pp().utils.appversion)
        // let version     = ref({})
        // let version     = ref(pp().utils.app_version_str)
        let version     = ref(appversion.value.current_version)

        // let version_str = computed(()=>{
        //     return version.value ? _.toString(version.value?.major || '?') +'.'+ _.toString(version.value?.minor || '?') +'.'+ _.toString(version.value?.patch || '?') : ''
        // })
        // let version_str = ref(version.value)
        let version_str = ref(version.value ? _.toString(version.value?.major) +'.'+ _.toString(version.value?.minor) +'.'+ _.toString(version.value?.patch) : '')


// log('in Versionning', appversion.value, version.value, version_str.value)

		// for form
		let saveDateToday   = ref(true)
		let openCustomDate  = ref(false)
		let customDate      = ref('')
		let updateManually  = ref(false)


		// others
		let openModalOldVersions = ref(false)

		// let showModalBadVersion = ref(false)
		// let timerAutoRefresh = ref(null)
		// let countdownAutoRefresh = ref(20) // 20 used in a watch too...


        _.defer(()=>{

			// version.value = appversion.value.current_version
			// version.value = pp().utils.app_version_str

            // if(pp().user && isBadVersion()){ // not auto. in login page
            //     showModalBadVersion.value = true // first load
            // }

            // _.defer(()=>{
                if(allRight()){ // pour un éventuel changement de version
                    // if(this.appversion.old_version.length >= this.maxOldVersions){
                    // 	this.appversion.old_version = _.take(this.appversion.old_version, this.maxOldVersions); // ne garder que les 19 dernières
                    // }

                    old_version =_.clone(_.omit(appversion.value, ['current_version','old_version'])) // no reactive variable
                    old_version.version = appversion.value.current_version?.major +'.'+ appversion.value.current_version?.minor +'.'+ appversion.value.current_version?.patch
                }
            // });
        })


		function allRight(){ return pp().isMaster }

		function isBadVersion(){
			// return _.toNumber(_.camelCase(app_state().appversion)) < _.toNumber(_.camelCase(version_str.value))
			return _.toNumber(_.camelCase(pp().user?.app_version)) < _.toNumber(_.camelCase(version.value))
		}

        // onBeforeUnmount(()=>{
        //     clearTimeout(timerAutoRefresh.value)
        //     timerAutoRefresh.value = null
        // })

        // // watch(showModalBadVersion, v => {
		// // 	if(v && countdownAutoRefresh.value == 20){
		// // 		timerAutoRefresh.value = setInterval(()=>{ countdownAutoRefresh.value--; }, 1000);
		// // 	}
        // // })
        // // watch(countdownAutoRefresh, v => {
		// // 	if( ! v){ refresh(); }
        // // })
        // // watch(attrs, v => {
		// // 	if(isBadVersion()){ showModalBadVersion.value = true; }// after each loading page
        // // })

        // watch([showModalBadVersion, countdownAutoRefresh, pp()], ([v1, v2, v3]) => {

		// 	if(v1 && countdownAutoRefresh.value == 20){
		// 		timerAutoRefresh.value = setInterval(()=>{ countdownAutoRefresh.value--; }, 1000)
		// 	}

        //     if( ! v2){ refresh(); }

		// 	if(v3 && isBadVersion()){ showModalBadVersion.value = true }// after each loading page
        // })


		function decrementVersion(type){

			if(version.value[type] > 0){
				version.value[type]--
				writeInJson()
			} else {
				notify('warning', 'On ne pas peut aller plus bas que 0...')
			}
		}

		function incrementVersion(type){
            version.value[type]++;

            if(type == 'major'){
                version.value.minor = 0
                version.value.patch = 0
            }
            if(type == 'minor'){
                version.value.patch = 0
            }

			writeInJson();
		}


		/**
		 * Ecrit le json dans public/js/vuejs/appversion.json
		 * @param STR whatWrite  (info) pour n'enregistrer que le changement du texte de l'info (ou la version git), sans modifier autre chose
		 */
		function writeInJson(whatWrite){

			if(allRight()){

				var datas = appversion.value

				if( ! whatWrite){

					if(saveDateToday.value){
						datas.date = formatDate({withHours: true, format:'YYYY-MM-DD'})
					}
					else if(customDate.value) {
						datas.date = customDate.value
					}

                    _.each(datas.current_version, (v, type)=>{
                        datas.current_version[type] = _.toString(v)
                    })


					appversion.value.old_version.unshift(old_version)
				}

				axios.post(route('update-app-version'), {
						datas: datas,
						filename: file,
					}).then(()=>{

//						this.getJsonFile()
//							.then(()=>{
//
							if( ! whatWrite){
								$q.dialog({
									title: 'Attention !',
									message: 'Pense aussi à modifier tout de suite app/state.js@appversion avec la même version ('+version_str.value+') !',
									ok: true, preventClose: true
								})
							}
//						});

					}).catch((error)=>{ e('Versioning.vue (update AppVersion in json file) writeInJson', error) })
			}
		}


		function updateManuallyBeforeWriteInJson(){

			var v_split = _.split(version_str.value, '.');

			version.value.major = _.toString(v_split[0])
			version.value.minor = _.toString(v_split[1])
			version.value.patch = _.toString(v_split[2])

			updateManually.value = false; // disable input

			writeInJson();
		}


		// function stopTimerAutoRefresh(){
		// 	clearInterval(timerAutoRefresh.value)
		// 	timerAutoRefresh.value = null
		// }

        return {
            app_state, open, formatDate, nl2br, refresh, link,

            version_str, appversion, version,

            saveDateToday, openCustomDate, customDate, updateManually,

            openModalOldVersions,
            
            // showModalBadVersion, timerAutoRefresh, countdownAutoRefresh,

            allRight,
            isBadVersion,
            decrementVersion,
            incrementVersion,
            writeInJson,
            updateManuallyBeforeWriteInJson,
            // stopTimerAutoRefresh,
        }
    }

}

</script>
